module.exports = __webpack_public_path__ + "img/backgroundDV.de0e37bd.jpg";